module.exports = __webpack_public_path__ + "03_glasses_brown.b85defd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/03_glasses_brown.png
// module id = eT+K
// module chunks = 0